import React from "react";
import img from "./footer-shape.png";
const FooterShape = () => {
	return (
		<img src={img} alt="" />
		// <svg width={512} viewBox="0 0 512 625" fill="none">
		// 	<g filter="url(#filter0_f_21_131)">
		// 		<path
		// 			d="M57.1124 548.409C148.765 589.052 255.921 547.494 296.452 455.59C336.983 363.685 295.541 256.234 203.887 215.591C112.236 174.948 5.07941 216.505 -35.4516 308.41C-75.9828 400.315 -34.5404 507.766 57.1124 548.409Z"
		// 			fill="url(#paint0_radial_21_131)"
		// 			fillOpacity="0.7"
		// 		/>
		// 	</g>
		// 	<defs>
		// 		<filter
		// 			id="filter0_f_21_131"
		// 			x={-251}
		// 			y={0}
		// 			width={763}
		// 			height={764}
		// 			filterUnits="userSpaceOnUse"
		// 			colorInterpolationFilters="sRGB"
		// 		>
		// 			<feFlood floodOpacity={0} result="BackgroundImageFix" />
		// 			<feBlend
		// 				mode="normal"
		// 				in="SourceGraphic"
		// 				in2="BackgroundImageFix"
		// 				result="shape"
		// 			/>
		// 			<feGaussianBlur
		// 				stdDeviation={100}
		// 				result="effect1_foregroundBlur_21_131"
		// 			/>
		// 		</filter>
		// 		<radialGradient
		// 			id="paint0_radial_21_131"
		// 			cx={0}
		// 			cy={0}
		// 			r={1}
		// 			gradientUnits="userSpaceOnUse"
		// 			gradientTransform="translate(482.582 604.743) rotate(-154.377) scale(839.014 763.197)"
		// 		>
		// 			<stop offset="0.281116" stopColor="#00EBFF" />
		// 			<stop offset="0.67478" stopColor="#FF39B0" />
		// 			<stop offset="0.770833" stopColor="#161C1B" />
		// 		</radialGradient>
		// 	</defs>
		// </svg>
	);
};

export default FooterShape;
